import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import {
    ReactiveFormsModule,
    FormsModule
} from "@angular/forms";
import { NgxPermissionsModule } from "ngx-permissions";
import { MaterialModule } from "../material/material.module";
import { UsuarioService } from "../../providers/usuario.service";
import { AccionesPropuestaModule } from "./acciones-propuesta/acciones-propuesta.module";
import { BotonToggleModule } from "../boton/boton-toggle.module";
import { PanelPropuestasModule } from "./panel-propuestas/panel-propuestas.module";
import { ActividadesModule } from "../actividades/actividades.module";
import { ContactoModule } from "../../forms/entidad/contactos/contacto.module";
import { ActividadesService } from "../../providers/actividades.service";
import { CotizacionModule } from "../../forms/cotizaciones/cotizacion.module";
import { ListadoPropuestasComponent } from './listado-propuestas/listado-propuestas.component';
import { PropuestasComponent } from './propuestas.component';
import { PropuestasRoutingModule } from "./propuestas-routing.module";



@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        NgxPermissionsModule.forChild(),
        MaterialModule,
        AccionesPropuestaModule,
        BotonToggleModule,
        PanelPropuestasModule,
        ActividadesModule,
        ContactoModule,
        CotizacionModule,
        PropuestasRoutingModule,

    ],
    declarations: [
        ListadoPropuestasComponent,
        PropuestasComponent,
    ],
    entryComponents: [
    ],
    exports: [
        PanelPropuestasModule,
        AccionesPropuestaModule,
        ListadoPropuestasComponent,
    ],
    providers: [
        UsuarioService,
        ActividadesService
    ]
})
export class PropuestasModule { }
